import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { get } from '../utils/get';

export class InputQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { key } = this.options;
		const { inputs = {} } = executionOptions;
		return get(inputs, key);
	}
}